import questionTypeMultipleChoiceAsListTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/multiple_choice_display_as_list_question_template.ejs';
import questionTypeMultipleChoiceAsListRDPlusThemeTemplatePrechat from '../../templates/question_types/RDPlusTheme/prechat_rounded_theme/multiple_choice_display_as_list_question_template.ejs';
import questionTypeMultipleChoiceAsListTemplate from '../../templates/question_types/multiple_choice_display_as_list_question_template.ejs';
import questionTypeMultipleChoiceAsListRDPlusThemeTemplate from '../../templates/question_types/RDPlusTheme/mc_ata_display_as_list_question_template.ejs';
import WidgetTypes from '../../core/enums/WidgetTypes';

const ImportMCListTemplateFactory = (options) => {
    const isFromPreChat = options.widgetType === WidgetTypes.PreChat;
    const isFromVideoGreet = options.widgetType === WidgetTypes.VideoGreetInvitation;

    const defaultTemplates = {
        questionTypeMultipleChoiceAsListTemplate
    }
    const preChatTemplates = {
        questionTypeMultipleChoiceAsListTemplate: questionTypeMultipleChoiceAsListTemplatePrechat
    }
    const rdPlusTemplates = {
        questionTypeMultipleChoiceAsListTemplate: questionTypeMultipleChoiceAsListRDPlusThemeTemplate
    }
    const preChatRdPlusTemplates = {
        questionTypeMultipleChoiceAsListTemplate: questionTypeMultipleChoiceAsListRDPlusThemeTemplatePrechat
    }

    if (isFromPreChat || isFromVideoGreet) {
        if (ApexChat.IsRoundedDynamicPlusTheme) {
            return preChatRdPlusTemplates;
        }
        return preChatTemplates;
    }
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return rdPlusTemplates;
    }

    return defaultTemplates;
};
export default ImportMCListTemplateFactory;
